import { gql } from 'apollo-angular';
import BASIC_DATA_FIELDS from '../queries/segments/basic-data-fields';

const UPDATE_CUSTOM_SPEND_DATE_RANGE = gql`
  mutation updateRfpSpendDateRange(
    $id: Long!
    $customSpendStartDate: Date
    $customSpendEndDate: Date
  ) {
    updateRfpSpendDateRange(
      updateRfpSpendDateRangeRequest: {
        id: $id
        customSpendStartDate: $customSpendStartDate
        customSpendEndDate: $customSpendEndDate
      }
    ) {
      ${BASIC_DATA_FIELDS}
      hasPartialCategories
      spend {
        actualSpend
        continuedSpend
        annualizedSpend
      }
      potentialSavings {
        savingsVolume
      }
    }
  }
`;

export default UPDATE_CUSTOM_SPEND_DATE_RANGE;
